import React from "react";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { FadeLoader } from "react-spinners";

import ListViewItem from "./ListViewItem";
import { variant } from "../../../../../animations";

const ListView = () => {
  const searchResults = useSelector((state) => state.search);
  
  return (
    <motion.div
      variants={variant}
      initial="hidden"
      animate="visible"
      className="list-view"
    >
      {searchResults.loading && (
        <div className="loading">
          <div className="loading-spinner">
            <FadeLoader />
          </div>
        </div>
      )}
      {searchResults.results.map((item, index) => {
        return <ListViewItem key={index} item={item} />;
      })}
      {searchResults.results.length === 0 && !searchResults.loading && (
        <div className="nothing-found">
          <span>موردی یافت نشد :(</span>
        </div>
      )}
    </motion.div>
  );
};

export default ListView;
